import React from 'react';

import { connect } from 'react-redux';
import { Dispatch } from "redux";

import { InputElement, InputType } from '../../service/flowengine/model/Element';
import { getPageByKey, getPageByIndex } from '../../service/flowengine/FlowEngineAPI';
import { Page } from "../../service/flowengine/model/Page"

import { RootState } from '../../store/Store';
import { FlowState, updateFlowInputAction } from '../../store/reducers/FlowReducer'


// ---------------------------------------------------
// ---------------------------------------------------
// Properties
// ---------------------------------------------------

type Props = {
    pagename?: string;
}

// we need two portions of properties to have interfaces/types for each redux-mapping-method (mapStateToProps/mapDispatchToProps)
type PropsStatic = {
    flow: any
}

type PropsHandler = {
    updateFlowInput(state: FlowState): any,
}


// --------------------------------------------------
// ReactJS knows 2 basic styles of components:
//  - stateful componentes (also called "classes" or "class components"): these components know an internal "state"
//           They are inherited from a class extending React.Component and have a render-method returning the JSX-content
//              export default class Body extends React.Component<BodyProps, BodyState> {}
//
//  - stateless or "function components": these components have no internal state member, but can hold states via useState-hook
//           These components are simply functions returning the JSX content and are written like this
//                  export default function Body(props: BodyProps) { ... return JSX}
//                     or
//                  const Body : React.FunctionComponent<BodyProps> = (props) => {  ... return JSX }
//           Stateless components can maintain states not inherent by an internal state-variable, but by using useState hooks
//


// ---------------------------------------------------
// ---------------------------------------------------
// REDUX store
// ---------------------------------------------------

// Map component-properties to redux-store parts (input is the state, we return the according properties)
// this is the way from redux-store to component-properties
function mapStateToProps(state: RootState): PropsStatic {
  return {
    flow: state.flow.flow,                   // combined state  
  };
}

// Map handler to redux-store actions and place these handler methods into the component-props
// this is the way from component-properties to redux-store (by initiating actions in the redux-store to update it's state)
const mapDispatchToProps = (dispatch: Dispatch): PropsHandler => ({
  updateFlowInput: (state: FlowState) => dispatch(updateFlowInputAction(state)),
});

// Concatenate the two property-type-portions to a single property-type to be used in the component-creation
type FlowComponentProps = Props & PropsStatic & PropsHandler;


// ---------------------------------------------------

// ---------------------------------------------------
// ---------------------------------------------------
// Component
// ---------------------------------------------------
const GenericFlowOverview : React.FunctionComponent<FlowComponentProps> = (props) => {
    let listInputJSXElement = new Array<JSX.Element>();
    let pageToDisplay: Page | undefined = getPageByIndex(0);   // first page

    let isPageDumped: boolean = false;
    let elementcounter: number = 0;

    function dumpPageElements(p: Page | undefined): Array<JSX.Element> {
        let listInputJSXElement = new Array<JSX.Element>();

        if(p !== undefined && p.elements !== undefined) {
            let elements: InputElement[] = p.elements;
            for(let i=0; i < elements.length; i++) {
                let el: InputElement = elements[i];

                if(el.type === InputType.Image)
                    continue;

                if((el.isVisible !== undefined) && (el.isVisible() === false))
                    continue;

                //let outputValue: any = el.value;    // vorläufig für Demo
                let outputValue: any = el.getValue();    // vorläufig für Demo
                if(el.type === InputType.ValueBoolean) {
                    //outputValue = (el.value === true ? "Ja" : "Nein");
                    outputValue = (el.getValue() === true ? "Ja" : "Nein");
                }

                if(el.unit !== undefined && el.unit.length > 0) {
                    outputValue = outputValue + " " + el.unit;
                }
            
                listInputJSXElement.push(
                    <li key={elementcounter++}>{el.label + ": "} <i> {outputValue} </i></li>
                );
            }
        }

        return listInputJSXElement;
    }


    function dumpPage(p: Page | undefined): Array<JSX.Element> {
        let listInputJSXElement = new Array<JSX.Element>();
        if(p !== undefined) {
            listInputJSXElement.push(
                <div key={elementcounter++}>
                    <b>{p.label}</b>
                    <ul style={{marginTop: "1px", marginBottom: "10px"}}>
                        {dumpPageElements(p)}
                    </ul>
                </div>
            );
        }
        isPageDumped = true;

        return listInputJSXElement;
    }

    //
    // we iterate over the pages beginning by the first page and take all subsequent nextResolver-Pages. 
    // For each page we take the first optional of multiple element according
    // list the contents.
    // Do this until we reach the page currently displayed:
    /*
    listInputJSXElement.push (
        <h3 key={elementcounter++}>Previous input:</h3>
    );
    */

    while(pageToDisplay !== undefined) {
        if(props.pagename === undefined) {
            break;
        }

        if(props.pagename === pageToDisplay.id)
            break;

        listInputJSXElement.push (
            <div key={elementcounter++}>{dumpPage(pageToDisplay)}</div>
        );
        
        // if currently displayed page is the page we show right now: break
        let currentKey: string = pageToDisplay.id as string;  //getKeyForName(pageToDisplay.name);
        if(currentKey === props.pagename)
            break;

        // get next page key:
        let nextpagekey: string = pageToDisplay.nextResolver();

        // if next page is the same than the page before: break to avoid infinite loops
        let nextPageToDisplay: Page | undefined = getPageByKey(nextpagekey);
        if(nextPageToDisplay === undefined || nextPageToDisplay.name === pageToDisplay.name)
            break;

        pageToDisplay = nextPageToDisplay;

        // if next page is the page we show right now: break
        if(nextpagekey === props.pagename)
            break;
    }


    if(isPageDumped === false) {
        listInputJSXElement.push (
            /*<h4 key={elementcounter++}>----</h4>*/
            <h4 key={elementcounter++}> </h4>
        );
    }


    // ----
    return (
        <div style={{ overflow: "auto", height:"750px" }}>
            {listInputJSXElement}
        </div>
    );

}

export default connect(mapStateToProps, mapDispatchToProps)(GenericFlowOverview);
